module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./indexView.js"));
	}, "IntegralWalletView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=IntegralWalletView!./src/pages/Shop/Member/Wallet/IntegralWallet/indexView.js
// module id = 1002
// module chunks = 438